import { takeLatest, call, put } from "redux-saga/effects";
import { fetchDataBegin, fetchDataError, getCompanySuccess } from "./slice";
import { apiGet, apiPost } from "../../api/callApi";
import { getCompany } from "./actions";

function* getCompanyData(action) {
  yield put(fetchDataBegin());
  try {
    const response = yield call(apiGet, `/v1/getcompany`, false);
    yield put(getCompanySuccess({ newData: response.data }));
  } catch (error) {
    yield put(fetchDataError({ message: error.response.data.message }));
    console.error("Get company failed", error);
  }
}

export function* watchCompany() {
  yield takeLatest(getCompany.type, getCompanyData);
}
